import LoginOTPBlock from "../../components/LoginOTPBlock";
import styles from "./loginotppage.module.css";
import HeaderPage from "../../components/HeaderPage";
import HexagonComponent from "../../components/HexagonComponent";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

export default function LoginOTPPage() {
  return (
    <div className={`container-fluid ${styles.page}`}>
      <HeaderPage />
      <div className={`row my-5 ${styles.logoandloginBlock}`}>
        <div
          className={`col-lg-4 col-xl-4 col-md-6 col-sm-4 ${styles.hexagonlogoContainer}`}
        >
          <HexagonComponent />
        </div>
        <div
          className={`col-lg-4 col-xl-4 col-md-6 col-sm-3 ${styles.loginContainer}`}
        >
          <LoginOTPBlock />
        </div>
      </div>
    </div>
  );
}
